import React from 'react';
import { HeroVariant71 } from '../components/HeroVariant71';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage71() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1774">
      <Navigation data-id="element-1775" />
      <main data-id="element-1776">
        <HeroVariant71 data-id="element-1777" />
        <WhyUs data-id="element-1778" />
        <Services data-id="element-1779" />
        <FAQ data-id="element-1780" />
        <Testimonials data-id="element-1781" />
        <Consultation data-id="element-1782" />
      </main>
      <Footer data-id="element-1783" />
      <CookieBanner data-id="element-1784" />
      <FloatingContact data-id="element-1785" />
    </div>;
}